(async () => {

  if (!customElements.get('images-row-slider')) {

    const { default: Swiper, Navigation, Autoplay } = await import("swiper");

    Swiper.use([
      Navigation,
      Autoplay
    ]);

    class ImagesRowSlider extends HTMLElement {
      constructor() {
        super();
        this.swiperElement = this.querySelector('[data-swiper-images-row]');
        this.swiperOptions = {
          threshold: 10,
          observer: true,
          slidesPerView: 2,
          scrollbar: false,
          pagination: false,
          breakpointsInverse: true,
          centerInsufficientSlides: true,
          spaceBetween: 13,
          breakpoints: {
            320: {
              slidesPerView: 2,
            },
            480: {
              slidesPerView: 3,
            },
            1024: {
              slidesPerView: 4,
            },
          },
        };

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);
          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            };
          }
        }

        // re-init slider when Theme Editor is active
        if (Shopify.designMode && this.swiperInstance) {
          window.addEventListener('shopify:section:load', () => {
            this.swiperInstance.update();
          });
        }
        this.init();
      }

      init() {
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
      }

    }

    window.ImagesRowSlider = ImagesRowSlider;

    customElements.define('images-row-slider', ImagesRowSlider);

  }

})();